export default __webpack_public_path__ + "static/media/9.4f42153d.jpg";